import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const ProductLaunchCampaign = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <rect
          y="0.222656"
          width="248"
          height="143"
          rx="8.03704"
          fill="#F6F1EB"
        />
        <rect
          x="141.537"
          y="19.3848"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          fill="white"
        />
        <rect
          x="141.537"
          y="19.3848"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          stroke="#1E1E1E"
          strokeWidth="1.5"
        />
        <path
          d="M158.319 30.2171C158.319 33.2229 156.13 35.7142 153.269 36.1658V31.9578H154.663L154.929 30.2171H153.269V29.0876C153.269 28.6112 153.501 28.1471 154.244 28.1471H154.999V26.6652C154.999 26.6652 154.314 26.5476 153.659 26.5476C152.292 26.5476 151.398 27.3812 151.398 28.8905V30.2171H149.879V31.9578H151.398V36.1658C148.537 35.7142 146.348 33.2229 146.348 30.2171C146.348 26.8915 149.028 24.1953 152.333 24.1953C155.639 24.1953 158.319 26.8915 158.319 30.2171Z"
          fill="#1877F2"
        />
        <path
          d="M154.663 31.9086L154.928 30.1785H153.268V29.0558C153.268 28.5825 153.5 28.1211 154.243 28.1211H154.998V26.6481C154.998 26.6481 154.313 26.5312 153.658 26.5312C152.291 26.5312 151.398 27.3598 151.398 28.8599V30.1785H149.878V31.9086H151.398V36.091C151.702 36.1388 152.015 36.1638 152.333 36.1638C152.651 36.1638 152.963 36.1388 153.268 36.091V31.9086H154.663Z"
          fill="white"
        />
        <rect
          x="141.537"
          y="47.5137"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          fill="white"
        />
        <rect
          x="141.537"
          y="47.5137"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          stroke="#1E1E1E"
          strokeWidth="1.5"
        />
        <g clipPath="url(#clip0_3664_24891)">
          <path
            d="M148.959 64.2947H146.375V56.1728H148.959V64.2947ZM154.325 58.5598C154.023 58.5598 153.733 58.6783 153.52 58.8893C153.307 59.1003 153.187 59.3865 153.187 59.6849V64.2947H150.469V56.1728H153.187V57.0088C153.824 56.4757 154.628 56.1783 155.463 56.1675C157.148 56.1675 158.318 57.4031 158.318 59.748V64.2947H155.463V59.6849C155.463 59.5367 155.435 59.3898 155.378 59.2527C155.321 59.1156 155.237 58.9909 155.131 58.8859C155.026 58.7809 154.9 58.6975 154.761 58.6407C154.623 58.5838 154.475 58.5545 154.325 58.5545V58.5598ZM149.007 53.6386C149.007 53.8986 148.929 54.1527 148.783 54.3689C148.637 54.585 148.429 54.7535 148.186 54.853C147.943 54.9525 147.676 54.9785 147.418 54.9278C147.16 54.8771 146.923 54.7519 146.738 54.5681C146.552 54.3842 146.425 54.15 146.374 53.8951C146.322 53.6401 146.349 53.3758 146.449 53.1356C146.55 52.8954 146.72 52.6902 146.939 52.5457C147.158 52.4013 147.415 52.3242 147.678 52.3242C148.028 52.327 148.364 52.4667 148.611 52.7129C148.858 52.9591 148.996 53.2918 148.996 53.6386H149.007Z"
            fill="#0A66C2"
          />
        </g>
        <rect
          x="141.537"
          y="75.6445"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          fill="white"
        />
        <rect
          x="141.537"
          y="75.6445"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          stroke="#1E1E1E"
          strokeWidth="1.5"
        />
        <g clipPath="url(#clip1_3664_24891)">
          <path
            d="M152.333 80.6758C154.211 80.6758 154.434 80.6828 155.175 80.7168C157.081 80.8035 157.971 81.7078 158.058 83.5995C158.092 84.3409 158.099 84.5635 158.099 86.4412C158.099 88.3194 158.092 88.5415 158.058 89.2829C157.971 91.1728 157.083 92.0788 155.175 92.1656C154.434 92.1996 154.212 92.2066 152.333 92.2066C150.456 92.2066 150.233 92.1996 149.492 92.1656C147.581 92.0783 146.696 91.1699 146.609 89.2823C146.575 88.541 146.568 88.3188 146.568 86.4406C146.568 84.563 146.575 84.3409 146.609 83.5989C146.696 81.7078 147.584 80.803 149.492 80.7162C150.233 80.6828 150.456 80.6758 152.333 80.6758V80.6758ZM152.333 79.4082C150.423 79.4082 150.184 79.4164 149.434 79.4504C146.88 79.5676 145.461 80.9846 145.344 83.5409C145.309 84.2916 145.301 84.5307 145.301 86.4406C145.301 88.3505 145.309 88.5902 145.343 89.3403C145.46 91.8942 146.877 93.3136 149.433 93.4308C150.184 93.4648 150.423 93.473 152.333 93.473C154.243 93.473 154.483 93.4648 155.233 93.4308C157.784 93.3136 159.207 91.8966 159.323 89.3403C159.357 88.5902 159.366 88.3505 159.366 86.4406C159.366 84.5307 159.357 84.2916 159.323 83.5415C159.209 80.9899 157.79 79.5682 155.233 79.451C154.483 79.4164 154.243 79.4082 152.333 79.4082V79.4082ZM152.333 82.8295C150.339 82.8295 148.722 84.4463 148.722 86.4406C148.722 88.4349 150.339 90.0523 152.333 90.0523C154.327 90.0523 155.944 88.4355 155.944 86.4406C155.944 84.4463 154.327 82.8295 152.333 82.8295ZM152.333 88.7847C151.039 88.7847 149.989 87.7357 149.989 86.4406C149.989 85.1461 151.039 84.0965 152.333 84.0965C153.628 84.0965 154.677 85.1461 154.677 86.4406C154.677 87.7357 153.628 88.7847 152.333 88.7847ZM156.087 81.8432C155.621 81.8432 155.243 82.2212 155.243 82.6871C155.243 83.153 155.621 83.531 156.087 83.531C156.553 83.531 156.931 83.153 156.931 82.6871C156.931 82.2212 156.553 81.8432 156.087 81.8432Z"
            fill="url(#paint0_linear_3664_24891)"
          />
        </g>
        <rect
          x="141.537"
          y="103.773"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          fill="white"
        />
        <rect
          x="141.537"
          y="103.773"
          width="21.5926"
          height="21.5926"
          rx="10.7963"
          stroke="#1E1E1E"
          strokeWidth="1.5"
        />
        <g clipPath="url(#clip2_3664_24891)">
          <path
            d="M158.143 109.547H146.524C146.199 109.547 145.888 109.679 145.659 109.915C145.43 110.15 145.301 110.47 145.301 110.803V118.337C145.301 118.67 145.43 118.99 145.659 119.225C145.888 119.461 146.199 119.593 146.524 119.593H158.143C158.467 119.593 158.778 119.461 159.007 119.225C159.237 118.99 159.366 118.67 159.366 118.337V110.803C159.366 110.47 159.237 110.15 159.007 109.915C158.778 109.679 158.467 109.547 158.143 109.547Z"
            fill="white"
          />
          <path
            d="M158.143 109.547H146.524C146.199 109.547 145.888 109.679 145.659 109.915C145.43 110.15 145.301 110.47 145.301 110.803V118.337C145.301 118.67 145.43 118.99 145.659 119.225C145.888 119.461 146.199 119.593 146.524 119.593H158.143C158.467 119.593 158.778 119.461 159.007 119.225C159.237 118.99 159.366 118.67 159.366 118.337V110.803C159.366 110.47 159.237 110.15 159.007 109.915C158.778 109.679 158.467 109.547 158.143 109.547Z"
            stroke="#1E1E1E"
            strokeWidth="1.40648"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M158.863 110.049L152.333 115.574L145.803 110.049"
            stroke="#1E1E1E"
            strokeWidth="1.40648"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M102.932 87.6292L99.287 81.3504L99.6546 80.6274L102.582 74.9193C102.734 74.606 102.76 74.2469 102.655 73.9141C102.551 73.5812 102.323 73.2991 102.018 73.1243L95.7071 69.4734L95.3122 62.2559C95.2971 61.9929 95.2064 61.7393 95.0509 61.525C94.8953 61.3107 94.6813 61.1446 94.4342 61.0463C94.2672 60.9757 94.0877 60.9389 93.9064 60.9383L86.6272 60.8779L82.6461 54.8016C82.4468 54.506 82.1428 54.2951 81.7947 54.2107C81.4465 54.1263 81.0797 54.1747 80.7672 54.3462L74.4459 57.9255L67.9521 54.6365C67.6357 54.4849 67.2739 54.4567 66.9387 54.5576C66.6035 54.6585 66.3197 54.881 66.1439 55.1808L62.4822 61.418L55.1976 61.7708C54.8388 61.7873 54.501 61.9403 54.2546 62.198C54.0081 62.4557 53.8721 62.7982 53.8749 63.1541L53.8473 70.3743L48.9651 73.4874L48.8911 73.5319L47.7346 74.2768C47.4372 74.4681 47.2253 74.7652 47.1424 75.1072C47.0595 75.4493 47.1119 75.8104 47.2887 76.1167L47.8369 77.0645L48.6464 78.4619L48.7061 78.5587L50.9337 82.3955L47.6526 88.8272C47.4872 89.1418 47.451 89.5082 47.5516 89.85C47.6521 90.1917 47.8817 90.4825 48.1925 90.6618L54.5066 94.3134L54.9015 101.531C54.9207 101.883 55.075 102.215 55.3329 102.459C55.5907 102.703 55.9325 102.841 56.2883 102.844L63.581 102.908L66.7247 107.702L66.8045 107.835L67.5622 108.984C67.7569 109.279 68.0579 109.491 68.4036 109.575C68.7493 109.658 69.1137 109.608 69.4221 109.435L72.9351 107.446L75.7434 105.855L82.2533 109.137C82.5723 109.302 82.9427 109.34 83.2875 109.241C83.6322 109.143 83.9246 108.916 84.1037 108.609L87.7586 102.375L95.0438 102.02C95.4026 102.003 95.7405 101.85 95.9869 101.593C96.2333 101.335 96.3693 100.992 96.3665 100.637L96.3761 95.9308L96.384 93.4111L102.499 89.4979C102.797 89.3036 103.009 89.0044 103.092 88.6605C103.176 88.3167 103.124 87.9536 102.948 87.6445L102.932 87.6292Z"
          fill="#FFEDBF"
        />
        <path
          d="M48.6453 78.4705L47.2876 76.122C47.1106 75.8156 47.0583 75.4544 47.1412 75.1123C47.2241 74.7702 47.436 74.4731 47.7336 74.2817L53.8512 70.3679L53.8791 63.1435C53.8804 62.791 54.0178 62.453 54.2631 62.1988C54.5083 61.9446 54.843 61.7934 55.1984 61.7761L62.4866 61.4209L66.1434 55.1838C66.3192 54.8823 66.6041 54.6584 66.9408 54.5571C67.2775 54.4559 67.6411 54.4849 67.9584 54.6382L74.468 57.9342L80.7917 54.3544C81.1003 54.1808 81.4647 54.1307 81.8106 54.2145C82.1565 54.2984 82.4576 54.5097 82.6524 54.8054L86.6355 60.8832L93.9312 60.9473C94.2871 60.9504 94.6291 61.0881 94.8871 61.3323C95.145 61.5764 95.2994 61.9086 95.3187 62.2606L95.7141 69.4798L102.031 73.1324C102.343 73.3114 102.573 73.6022 102.674 73.9442C102.775 74.2862 102.739 74.653 102.574 74.9682L99.2983 81.3743L102.945 87.6546C103.122 87.961 103.174 88.3222 103.092 88.6643C103.009 89.0064 102.797 89.3035 102.499 89.4949L96.3815 93.4087L96.3678 100.634C96.3706 100.99 96.2346 101.332 95.988 101.59C95.7415 101.848 95.4035 102.001 95.0446 102.017L87.7564 102.372L84.0996 108.609C83.92 108.916 83.6274 109.142 83.2828 109.24C82.9381 109.338 82.5679 109.301 82.2492 109.135L75.7364 105.853L69.4126 109.432C69.1041 109.606 68.7396 109.656 68.3938 109.572C68.0479 109.488 67.7468 109.277 67.552 108.981L66.7945 107.829"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.5293 95.5254L47.2818 101.084"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.978 70.752L78.2392 91.8728"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.4912 90.7597L46.5308 99.9718L44.2802 96.6366L64.7275 71.8623L77.4911 90.7575L77.4912 90.7597Z"
          fill="#FF5A4F"
        />
        <path
          d="M77.4912 90.7597L46.5308 99.9718L44.2802 96.6366L64.7275 71.8623L77.4911 90.7575L77.4912 90.7597Z"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.6404 95.1787C63.066 95.6597 63.3882 96.2216 63.5869 96.8297C63.7856 97.4379 63.8566 98.0793 63.7956 98.7145C63.7346 99.3497 63.5428 99.9651 63.2322 100.523C62.9215 101.08 62.4985 101.568 61.9893 101.957C61.4802 102.345 60.8956 102.625 60.2717 102.78C59.6479 102.935 58.998 102.962 58.3622 102.858C57.7264 102.754 57.1181 102.522 56.575 102.176C56.0319 101.831 55.5655 101.379 55.2046 100.849L53.2445 97.9463"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M74.2305 76.3066L80.5961 69.4505"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M77.2324 80.0039L82.9918 79.9472"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M129.321 36.3438L123.697 40.6828"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.941 35.8407L129.372 36.4105L128.799 40.8414"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.113 63.3594L123.009 63.3594"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.952 66.4355L130.113 63.2776L126.952 60.1196"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.113 86.5469L123.009 86.5469"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.952 89.623L130.113 86.4651L126.952 83.3071"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.321 113.398L123.697 109.059"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.941 113.901L129.372 113.332L128.799 108.901"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3664_24891"
            x1="155.263"
            y1="79.4082"
            x2="150.299"
            y2="92.6111"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_3664_24891">
            <rect
              width="11.9705"
              height="11.9705"
              fill="white"
              transform="translate(146.348 52.3242)"
            />
          </clipPath>
          <clipPath id="clip1_3664_24891">
            <rect
              width="14.0648"
              height="14.0648"
              fill="white"
              transform="translate(145.301 79.4082)"
            />
          </clipPath>
          <clipPath id="clip2_3664_24891">
            <rect
              width="16.0741"
              height="16.0741"
              fill="white"
              transform="translate(144.296 106.533)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
ProductLaunchCampaign.displayName = 'ProductLaunchCampaign';
